import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import MoneyFormatter from "../utils/money-formatter";
import CashoutService from "../../../services/cashout";
import Ticket from "../../../services/ticket";
import Observer from "../utils/observer";
import {
	CashoutOptionsModal as AwrabetCashoutOptionsModal,
	CashoutTabs as AwrabetCashoutTabs,
	PartialCashoutTab as AwrabetPartialCashoutTab,
	AutoCashoutTab as AwrabetAutoCashoutTab,
	CashoutOptionsTooltip as AwrabetCashoutOptionsTooltip,
	CashoutOptionsContent as AwrabetCashoutOptionsContent,
	Slider as AwrabetSlider
} from '../../awrabet/desktop-components/autocashout-tooltip.jsx';

export class CashoutOptionsModal extends AwrabetCashoutOptionsModal {

    render({ children, row, onClose }) {
        return (
            <div ref={r => this.modalRoot = r} data-id={row.ticketId} class="absolute top-10 left-0 rounded w-[350px] z-20 bg-slate-100 shadow border border-gray-600">
                {children}
            </div>
        );
    }
}

/**
 * Richiede che i children abbiano l'attibuto "tabName"
 */
export class CashoutTabs extends AwrabetCashoutTabs {

    render({ children }, { activeTab }) {
        return (
            <Fragment>
                <div class="flex items-center justify-center text-sm text-center bg-slate-200 rounded-t">
                    {children.map((child, index) => (
                        <a
                            key={index}
                            class={
                                "w-full hover:bg-slate-300 py-2 first:rounded-tl last:rounded-tr" +
                                (activeTab === index ? " border-b-2 border-amber-400" : "")
                            }
                            href="javascript:void(0);"
                            onClick={e => this.onTabChange(index)}
                        >
                            {child.props.tabName}
                        </a>
                    ))}
                </div>
                {/* Mostra il contenuto della tab attiva */}
                <div class="p-2">
                    {children[activeTab]}
                </div>
            </Fragment>
        );
    }
}

export class PartialCashoutTab extends AwrabetPartialCashoutTab {

    render({ row }, { bet, win, minbet, maxbet, cashout }) {
        return (
            <Fragment>
                <h4 class="flex panel-h4-flex text-left" style="padding-bottom:1px">
                    <span class="panel-flex-title"><Trans>Partial Bet</Trans></span>
                    <span class="flex-shrink-0 text-right w-20">
                        <MoneyFormatter value={bet} currency={row.currency} />
                    </span>
                </h4>
                <h4 class="flex panel-h4-flex text-left" style="padding-top:1px">
                    <span class="panel-flex-title"><Trans>Cashout Win</Trans></span>
                    <span class="flex-shrink-0 text-right w-20">
                        <MoneyFormatter value={win} currency={row.currency} />
                    </span>
                </h4>
                <div class="relative py-2">
                    <Slider
                        minLabel={MoneyFormatter({ value: minbet, currency: row.currency })}
                        maxLabel={MoneyFormatter({ value: maxbet, currency: row.currency })}
                        startvalue={bet / row.betAmount}
                        onChange={percent => {
                            const newBet = maxbet * percent;
                            this.setState({
                                bet: newBet < minbet ? minbet : newBet,
                                win: CashoutService.calculateCashoutWin({ ...row, betAmount: newBet < minbet ? minbet : newBet })
                            });
                        }}
                    />
                </div>
                <div class="py-2">
                    <a
                        href="javascript:void(0)"
                        class={"inline-block py-1 px-4 text-xs font-bold rounded leading-5 button-minimal w-full grow bg-amber-500 text-center uppercase cursor-pointer hover:bg-amber-400"}
                        onClick={e => {
                            if (!!cashout) {
                                this.confirmPartialCashout(row, bet);
                            }
                        }}
                    >
                        {!!cashout ? <Trans>Confirm</Trans> : <i class="fa fa-lock" />}
                    </a>
                </div>
            </Fragment>
        );
    }
}

export class AutoCashoutTab extends AwrabetAutoCashoutTab {

    render({ row, ticket }, { allowmax, allowmin, min, max, maxwin }) {
        return (
            <div class="p-2 flex flex-col items-center justify-center text-base gap-1">
                <div class="py-2 w-full flex items-center justify-center gap-1">
                    <span>
                        <input
                            type="checkbox"
                            id={"max-" + ticket.ticketId}
                            checked={allowmax}
                            onClick={e => {
                                this.setState({ allowmax: !allowmax });
                            }}
                        />
                    </span>
                    <span class={"flex-shrink-0" + (!allowmax ? ' text-gray-400' : '')}>
                        <label htmlFor={"max-" + ticket.ticketId}><Trans>If the value reaches ( &gt;= )</Trans></label>
                    </span>
                    <span class="w-full text-right">
                        <span class={"mr-2" + (!allowmax ? ' text-gray-400' : '')}>{row.currency}</span>
                        <input
                            type="number"
                            disabled={!allowmax}
                            class={"w-20 rounded font-bold pl-2" + (!allowmax ? ' text-gray-400' : '') + (max > maxwin || max <= min ? ' border-2 border-red-500' : ' border border-slate-200')}
                            value={max}
                            placeholder={maxwin}
                            onInput={e => {
                                this.setState({ max: e.target.value });
                            }}
                        />
                    </span>
                </div>
                <div class="py-2 w-full flex items-center justify-center gap-1">
                    <span>
                        <input
                            type="checkbox"
                            id={"min-" + ticket.ticketId}
                            checked={allowmin}
                            onClick={e => {
                                this.setState({ allowmin: !allowmin });
                            }}
                        />
                    </span>
                    <span class={"flex-shrink-0" + (!allowmin ? ' text-gray-400' : '')}>
                        <label htmlFor={"min-" + ticket.ticketId}><Trans>If the value drops below ( &lt;= )</Trans></label>
                    </span>
                    <span class="w-full text-right">
                        <span class={"mr-2" + (!allowmin ? ' text-gray-400' : '')}>{row.currency}</span>
                        <input
                            type="number"
                            disabled={!allowmin}
                            class={"w-20 rounded font-bold pl-2" + (!allowmin ? ' text-gray-400' : '') + (min <= 0.00 || min >= max ? ' border-2 border-red-500' : ' border border-slate-200')}
                            value={min}
                            placeholder={row.betAmount}
                            onInput={e => {
                                this.setState({ min: e.target.value });
                            }}
                        />
                    </span>
                </div>
                <div class={"py-2 w-full pt-3" + ((!!min) || (!!max) ? '' : ' opacity-60')}>
                    <a
                        href="javascript:void(0)"
                        class={"inline-block py-1 px-4 text-xs font-bold rounded leading-5 button-minimal w-full grow bg-amber-500 text-center uppercase cursor-pointer hover:bg-amber-400"}
                        onClick={e => {
                            if ((!!min) || (!!max)) {
                                this.confirmAutoCashout(row, { allowmin, allowmax, min, max });
                            }
                        }}
                    >
                        <Trans>Confirm</Trans>
                    </a>
                </div>
            </div>
        );
    }
}

export class CashoutOptionsTooltip extends AwrabetCashoutOptionsTooltip {
    render({ row, ticket, onClose, onPartialCashout, onAutoCashout }) {
        return (
            <CashoutOptionsModal row={row} onClose={onClose}>
                <CashoutOptionsContent
                    row={row}
                    ticket={ticket}
                    onPartialCashout={onPartialCashout}
                    onAutoCashout={onAutoCashout} />
            </CashoutOptionsModal>
        );
    }
}
export class CashoutOptionsContent extends AwrabetCashoutOptionsContent {
    render({ row, ticket, onPartialCashout, onAutoCashout }) {
        return (
            <CashoutTabs>
                <PartialCashoutTab tabName={<Trans>Partial Cashout</Trans>} row={row} minbet={Ticket.getMinBetAfterTax()} onPartialCashout={onPartialCashout} />
                <AutoCashoutTab tabName={<Trans>Automatic Cashout</Trans>} row={row} ticket={ticket} onAutoCashout={onAutoCashout} />
            </CashoutTabs>
        );
    }
}

export class Slider extends AwrabetSlider {

    render() {
        return <div>
            <div class="relative w-full">
                <div class="flex flex-row items-center justify-center w-full">
                    {this.getStepsArray()}
                </div>
                <div class="absolute left-0 top-0 right-0 bottom-0">
                    <div class="flex flex-row items-center justify-center w-full h-full">
                        {this.getDotsArray()}
                        {this.getDot()}
                    </div>
                </div>
            </div>
            {(!!this.state.maxLabel || !!this.state.minLabel) && <div class="flex flex-row items-center justify-center w-full">
                {!!this.state.minLabel && <span class="w-full text-left">{this.state.minLabel}</span>}
                {!!this.state.maxLabel && <span class="w-full text-right">{this.state.maxLabel}</span>}
            </div>}
        </div>;
    }
}
